import { useEffect } from 'react';

const PhotoModal = ({ photos, currentIndex = 0, onClose, onNext, onPrev }) => {
  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (event) => {
      switch (event.key) {
        case 'ArrowLeft':
          if (onPrev) {
            onPrev();
          }
          break;
        case 'ArrowRight':
          if (onNext) {
            onNext();
          }
          break;
        case 'Escape':
          onClose();
          break;
        default:
          break;
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    
    // Prevent scrolling when modal is open
    document.body.style.overflow = 'hidden';
    
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [onClose, onNext, onPrev]);
  
  // Get the current photo
  const currentPhoto = Array.isArray(photos) 
    ? photos[currentIndex] 
    : (photos || '');
  
  // Get the image URL
  const getImageUrl = () => {
    if (!currentPhoto) return '';
    // Handle both string paths and objects with path/url properties
    if (typeof currentPhoto === 'string') {
      return currentPhoto;
    }
    return currentPhoto.url || currentPhoto.path || '';
  };
  
  // Determine if there are multiple photos for navigation
  const hasMultiplePhotos = Array.isArray(photos) && photos.length > 1;
  
  return (
    <div className="photo-modal" onClick={onClose}>
      <div className="photo-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="photo-modal-close" onClick={onClose}>
          &times;
        </button>
        
        <div className="photo-container">
          <img 
            src={getImageUrl()} 
            alt={`Photo ${currentIndex + 1}`} 
            onError={(e) => {
              console.error('Failed to load image:', getImageUrl());
              e.target.src = '/cat-placeholder.png';
            }}
          />
          
          {hasMultiplePhotos && (
            <div className="photo-count">
              {currentIndex + 1} / {photos.length}
            </div>
          )}
        </div>
        
        {hasMultiplePhotos && onPrev && (
          <button 
            className="photo-modal-nav photo-modal-prev" 
            onClick={(e) => {
              e.stopPropagation();
              onPrev();
            }}
          >
            &lsaquo;
          </button>
        )}
        
        {hasMultiplePhotos && onNext && (
          <button 
            className="photo-modal-nav photo-modal-next" 
            onClick={(e) => {
              e.stopPropagation();
              onNext();
            }}
          >
            &rsaquo;
          </button>
        )}
      </div>
    </div>
  );
};

export default PhotoModal; 